import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { IRelationshipService } from './IRelationshipService';
import { RelationshipType } from './RelationshipType';
import { GetRelationshipRequest } from './GetRelationshipRequest';
import { GetRelationshipsRequest } from './GetRelationshipsRequest';
import { SearchRelationshipRequest } from './SearchRelationshipRequest';
import { IRelationshipResult } from './IRelationshipResult';
import { IRelationshipSearchResponse } from './IRelationshipSearchResponse';

class RelationshipService implements IRelationshipService {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    getRelationship(request: GetRelationshipRequest): Promise<IRelationshipResult> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/relationships/get',
            method: HttpMethod.POST
        }, request);

        return new Promise<IRelationshipResult>((resolve, reject) => {
            this.manager
                .get<IRelationshipResult>(req)
                .then((res) => {
                    if (res != null) {
                        resolve((res as IRelationshipResult));
                    } else {
                        resolve({
                            _id: request._id,
                            type: request.type,
                            disp: 'Unknown',
                            desc: 'Unknown'
                        } as IRelationshipResult);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    resolve({
                        _id: request._id,
                        type: request.type,
                        disp: 'Unknown',
                        desc: 'Unknown'
                    } as IRelationshipResult);
                })
        });
    }

    getRelationships(request: GetRelationshipsRequest): Promise<IRelationshipResult[]> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/relationships',
            method: HttpMethod.POST
        }, request);

        return new Promise<IRelationshipResult[]>((resolve, reject) => {
            this.manager
                .get<IRelationshipResult[]>(req)
                .then((res) => {
                    resolve((res ?? [] as IRelationshipResult[]));
                })
                .catch((err) => {
                    console.log(err);
                    resolve([]);
                })
        });
    }

    search(request: SearchRelationshipRequest): Promise<IRelationshipSearchResponse> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/relationships/search',
            method: HttpMethod.POST
        }, request);

        return new Promise<IRelationshipSearchResponse>((resolve, reject) => {
            this.manager
                .get<IRelationshipSearchResponse>(req)
                .then((res) => {
                    if (res != null) {
                        resolve(res);
                    } else {
                        resolve({
                            cnt: 0,
                            res: []
                        } as IRelationshipSearchResponse);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    resolve({
                        cnt: 0,
                        res: []
                    } as IRelationshipSearchResponse);
                })
        });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<IRelationshipService>('IRelationshipService', (frm) => {
        return new RelationshipService(frm);
    });
}